import React, { useEffect, useState } from 'react';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import { regions } from './areaConstants';
import { selectOptions } from '../js/utilityRoutines';

export default function RegionSelect(props) {
	const { userParams, setUserParams, setShowGoButton } = props;
	const [selectedIndex, setSelectedIndex] = useState(12);  // default Northeast (ME,WV)

	const handleMenuItemClick = (event) => {
		const index = parseInt(event.target.value);
		setSelectedIndex(index);
		// regions are saved as groups of states
		setUserParams({ ...userParams, areaType: "region", area: regions[index].states.replaceAll('-',',')});
		setShowGoButton(true);
	};

	useEffect(() => {
		// save default menu selection
		setUserParams({ ...userParams, areaType: "region", area: regions[selectedIndex].states.replaceAll('-',',')});
	}, []);


	return (
		<Box sx={{ mt: 0 }}>
			<TextField
				select
				name="region"
				id="region"
				label="Region"
				value={selectedIndex}
				sx={{ mt: 1 }}
				onChange={handleMenuItemClick}
				inputProps={{
					autoComplete:"off"
				}}
			>
				{selectOptions(regions)}
			</TextField>
		</Box>
	);
}

